/* Little Sonny theme — Judge.me reviews rendered in our own card design.
   Data comes from the existing Little Sonny review service (no keys in the theme). */
(function () {
  'use strict';

  var LS = window.LittleSonny || {};
  var cache = null;

  function fetchReviews() {
    if (cache) return cache;
    cache = fetch(LS.functionsUrl + '/judgeme-reviews', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: LS.anonKey,
        Authorization: 'Bearer ' + LS.anonKey
      },
      body: '{}'
    })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
    return cache;
  }

  function starRow(rating, size) {
    var px = size || 14;
    var html = '<span class="inline-flex items-center gap-0.5" aria-hidden="true">';
    for (var i = 1; i <= 5; i++) {
      var filled = rating >= i - 0.25;
      html +=
        '<svg width="' + px + '" height="' + px + '" viewBox="0 0 24 24" ' +
        (filled
          ? 'fill="hsl(var(--star))" stroke="hsl(var(--star))"'
          : 'fill="none" stroke="hsl(var(--star))"') +
        ' stroke-width="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
    }
    return html + '</span>';
  }

  function formatDate(iso) {
    try {
      return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch (error) {
      return '';
    }
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : value;
    return div.innerHTML;
  }

  function renderStars(root, data) {
    root.innerHTML =
      '<button type="button" class="flex items-center gap-2 group" data-scroll-to="#judgeme-reviews">' +
      starRow(data.average, 16) +
      '<span class="type-small text-muted-foreground group-hover:text-foreground transition-colors">' +
      data.average.toFixed(1) + ' (' + data.count + (data.count === 1 ? ' review' : ' reviews') + ')' +
      '</span></button>';
  }

  function reviewCard(review) {
    return (
      '<article class="border border-border p-6 flex flex-col gap-3">' +
      starRow(review.rating) +
      (review.title ? '<h3 class="type-body font-medium">' + escapeHtml(review.title) + '</h3>' : '') +
      '<p class="type-body-sm text-muted-foreground whitespace-pre-line">' + escapeHtml(review.body) + '</p>' +
      (review.picture
        ? '<img src="' + review.picture + '" alt="Customer photo from ' + escapeHtml(review.name) +
          '" loading="lazy" class="w-full aspect-square object-cover">'
        : '') +
      '<div class="mt-auto pt-2"><p class="type-body-sm font-medium">' + escapeHtml(review.name) + '</p>' +
      '<p class="type-caption text-muted-foreground">' +
      (review.verified ? 'Verified purchase · ' : '') + formatDate(review.createdAt) +
      '</p></div></article>'
    );
  }

  function renderList(root, data) {
    var pageSize = Number(root.dataset.pageSize || 6);
    var visible = pageSize;

    function paint() {
      var shown = data.reviews.slice(0, visible);
      root.innerHTML =
        '<div class="text-center mb-10">' +
        '<p class="type-eyebrow text-muted-foreground mb-3">VERIFIED CUSTOMER REVIEWS</p>' +
        '<div class="flex items-center justify-center gap-3 mt-4">' + starRow(data.average, 18) +
        '<span class="type-body-sm text-muted-foreground">' + data.average.toFixed(1) +
        ' out of 5 · ' + data.count + (data.count === 1 ? ' review' : ' reviews') + '</span></div></div>' +
        '<div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">' +
        shown.map(reviewCard).join('') +
        '</div>' +
        (visible < data.reviews.length
          ? '<div class="text-center mt-10"><button type="button" data-load-more class="type-eyebrow border border-foreground px-8 py-4 btn-swipe">LOAD MORE REVIEWS</button></div>'
          : '');

      var more = root.querySelector('[data-load-more]');
      if (more) {
        more.addEventListener('click', function () {
          visible += pageSize;
          paint();
        });
      }
    }
    paint();
  }

  function init() {
    var starTargets = document.querySelectorAll('[data-judgeme-stars]');
    var listTargets = document.querySelectorAll('[data-judgeme-reviews]');
    if (!starTargets.length && !listTargets.length) return;

    fetchReviews().then(function (data) {
      if (!data || !data.count) return;
      starTargets.forEach(function (root) { renderStars(root, data); });
      listTargets.forEach(function (root) {
        root.closest('[data-judgeme-section]')?.classList.remove('hidden');
        renderList(root, data);
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
